<template>
  <div class="textAndImg2" :id="data.anchor">
    <div class="text">
      <div class="main">
        <span
          class="icon"
          :style="{'backgroundImage':'url('+data.icon+')'}">
        </span>
        <h2>{{ data.title }}</h2>
        <p>{{ data.text }}</p>
      </div>
    </div>
    <div
      class="img">
      <span
        class="bg"
        :style="{'background':data.bgColor}">
      </span>
      <span
        class="bgDecorate"
        :style="{'backgroundColor':data.bgDecorate}">
      </span>
      <img :src="data.img" alt="">
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      default: {

      }
    }
  },
}
</script>
<style lang="stylus" scoped>
.textAndImg2 {
  display: flex;
  height: 830px;
  & .text {
    width: 36%;
    & .main {
      margin-top: 146px;
      width: 300px;
    }
    & .icon {
      display: inline-block;
      background-size: cover;

      width: 80px;
      height: 80px;
    }
    & h2 {
      font-size: 36px;
      line-height: 60px;
      margin-top: 48px;
      color: rgba(0, 0, 0, 0.85);
    }
    & p {
      font-size: 20px;
      line-height: 36px;
      margin-top: 30px;
      color: rgba(0, 0, 0, 0.65);
    }
  }
  & .img {
    width: 64%;
    height: 100%;
    position: relative;
    line-height: 1;
    display: flex;
    align-items: center;
    & .bg {
      position: absolute;
      z-index: 1;
      width: 85%;
      left: 15%;
      top: 0;
      height: 100%;
    }
    & .bgDecorate {
      position: absolute;
      z-index: 2;
      left: 15%;
      top: 345px;
      width: 207px;
      height: 415px
      border-radius: 0 207px 207px 0;

    }
    & img {
      width: 95%;
      position: relative;
      z-index: 3;
    }

  }
}
</style>
